import HPassword from './HPassword.vue'

// 为组件提供 install 安装方法，供按需引入
HPassword.install = function (Vue) {
    Vue.component(HPassword.name, HPassword)
}
  
// 默认导出组件
export default HPassword